import translations from '@shopify/polaris/locales/es.json';

/**
 * i18n centralizado para Shopify Polaris (es).
 * - Evita duplicación de AppProvider en distintos wrappers/layouts.
 * - Mantiene abreviaturas de DatePicker estilo Shopify (minúsculas).
 */
export const polarisI18n = {
  ...translations,
  Polaris: {
    ...(translations as Record<string, unknown>).Polaris as Record<string, unknown>,
    DatePicker: {
      ...((translations as Record<string, unknown>).Polaris as Record<string, unknown> | undefined)?.DatePicker as Record<string, unknown> | undefined,
      daysAbbreviated: {
        monday: 'lu',
        tuesday: 'ma',
        wednesday: 'mi',
        thursday: 'ju',
        friday: 'vi',
        saturday: 'sa',
        sunday: 'do',
      },
    },
  },
} as const;

